import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "strength-meter",
  template: `
    <div class="strength-meter">
      <div class="strength-meter-fill"
        [attr.data-strength]="passwordScore"
      ></div>
    </div>
  `,
  styleUrls: ["./strength.meter.style.scss"]
})
export class StrengthMeterComponent implements OnChanges {
  @Input() passwordScore = 0;

  constructor() {}

  ngOnChanges(changes) {}
}
